import { TutorPackage } from '~/types/booking'
import { Product } from '~/types/product'

export default function formatTutoringProductPrices(products: Product[]): Product[] {
  const formattedProducts = products.map((product) => {
    const priceHourly = product.type === TutorPackage.HOURS_1 ? product.price : getNextOddPrice(product.priceHourly)
    const priceHourlyWithTravelExpense = product.priceHourly + product.travelExpenseHourly
    const priceTotalWithTravelExpense = product.price + product.travelExpense

    return {
      ...product,
      priceHourly,
      priceHourlyWithTravelExpense,
      priceTotalWithTravelExpense,
    }
  })

  return formattedProducts.sort((a, b) => a.minutes - b.minutes)
}

function getNextOddPrice(price: number): number {
  price = Math.ceil(price)
  return price % 2 === 0 ? price + 1 : price
}
